import { useEffect, useState } from "react";
import { Loader2 } from "lucide-react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { api, errMsg } from "@/lib/api";
import { fmtDate } from "@/lib/format";

export const BackupCustomersDialog = ({ backup, onClose, onPick }) => {
  const [list, setList] = useState(null);
  const [sel, setSel] = useState("");

  useEffect(() => {
    setList(null);
    setSel("");
    if (!backup) return;
    api.get(`/admin/backups/${backup.id}/customers`)
      .then((r) => setList(r.data))
      .catch((e) => { toast.error(errMsg(e)); onClose(); });
  }, [backup, onClose]);

  return (
    <Dialog open={!!backup} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="sm:max-w-lg" data-testid="backup-customers-dialog">
        <DialogHeader>
          <DialogTitle>Gjenopprett én kunde</DialogTitle>
          <DialogDescription>Backup fra {backup && fmtDate(backup.created_at)}. Velg kunden som skal settes tilbake. De andre kundene påvirkes ikke.</DialogDescription>
        </DialogHeader>
        {!list ? (
          <div className="py-8 flex justify-center text-slate-500" data-testid="backup-customers-loading"><Loader2 className="w-5 h-5 animate-spin" /></div>
        ) : (
          <div className="max-h-80 overflow-y-auto space-y-2" role="radiogroup">
            {list.map((x) => (
              <label key={x.entry} className={`flex items-start gap-3 rounded-md border px-3 py-2.5 cursor-pointer transition-colors ${sel === x.entry ? "border-sky-500 bg-sky-50" : "border-slate-200 hover:border-sky-300"}`}
                data-testid={`backup-customer-${x.customer_id}`}>
                <input type="radio" name="bc" className="mt-1 accent-sky-700" checked={sel === x.entry} onChange={() => setSel(x.entry)} />
                <span className="min-w-0">
                  <span className="block font-medium text-slate-900">{x.customer_name}</span>
                  <span className="block text-xs text-slate-500">
                    {x.counts?.users ?? 0} brukere · {x.counts?.pax_submissions ?? 0} passasjerrapporter · {x.counts?.pax_actors ?? 0} rederier{!x.exists && " · finnes ikke i dag"}
                  </span>
                </span>
              </label>
            ))}
            {!list.length && <p className="py-6 text-center text-sm text-slate-500">Ingen kunder i denne backupen.</p>}
          </div>
        )}
        <DialogFooter>
          <Button variant="outline" onClick={onClose} data-testid="backup-customers-cancel">Avbryt</Button>
          <Button disabled={!sel} onClick={() => onPick({ bid: backup.id, entry: sel })} data-testid="backup-customers-next">Fortsett</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
